const roleTypes = [
    {
        type: 'Fan',
        route: 'Fans',
        friendlyName: 'Fan',
        public: true
    },
    {
        type: 'Artist',
        route: 'Artists',
        friendlyName: 'Artist',
        public: true
    },
    {
        type: 'Manager',
        route: 'Managers',
        friendlyName: 'Manager',
        public: true
    },
    {
        type: 'Musician',
        route: 'Musicians',
        friendlyName: 'Musician',
        public: true
    },
    {
        type: 'Producer',
        route: 'Producers',
        friendlyName: 'Producer',
        public: true
    },
    {
        type: 'Promoter',
        route: 'Promoters',
        friendlyName: 'Promoter',
        public: true
    },
    {
        type: 'RecordLabel',
        route: 'RecordLabels',
        friendlyName: 'Record Label',
        public: true
    },
    {
        type: 'RecordingStudio',
        route: 'RecordingStudios',
        friendlyName: 'Recording Studio',
        public: true
    },
    {
        type: 'Songwriter',
        route: 'Songwriters',
        friendlyName: 'Songwriter',
        public: true
    },
    {
        type: 'Venue',
        route: 'Venues',
        friendlyName: 'Venue',
        public: true
    },
    {
        type: 'Writer',
        route: null,
        friendlyName: 'Writer',
        public: false
    },
]

export default roleTypes;